module.exports = __webpack_public_path__ + "static/media/01C.368a5d50.png";